
import React, { useState } from "react";
import { X } from "lucide-react";
import Moment from "react-moment";
import DetailsModal from "../components/Modal/DetailsModal";

const ApiLogsTable = ({ logs,loading }) => {
  const handleSort = (key) => {
    console.log(`Sorting by ${key}`);
   
  };

  const handleStatusToggle = (key, isActive) => {
    console.log(`Toggling status for ${key}: ${isActive}`);
    
  };

  const navigate = (url) => {
    console.log(`Navigating to ${url}`);
    
  };

  return (
    <table className="w-full">
        
      <thead className="bg-gray-50">
        <tr>
          <th onClick={() => handleSort("key")} className="px-6 py-3 text-left cursor-pointer">
            Key
          </th>
          <th className="px-6 py-3 text-left">Module</th>
          <th className="px-6 py-3 text-left">Details</th>
          <th className="px-6 py-3 text-left">Status</th>
          <th className="px-6 py-3 text-left">Created At</th>
      <th className="px-6 py-3 text-left">User ID</th>
      {/* <th className="px-6 py-3 text-left">User</th> */}
      <th className="px-6 py-3 text-left">Comment</th>
      <th className="px-6 py-3 text-left">HTTP Method</th>

         
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200"> {loading ? (   <tr>
              <td colSpan={6} className="px-6 py-10 text-center">
                <div className="flex justify-center">
                  <div className="w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              </td>
            </tr>
          ) : logs?.length === 0 ? (
            <tr>
              <td colSpan={6} className="px-6 py-10 text-center text-gray-500">
                No logs found
              </td>
            </tr>
          ) : (
        logs.map((log) => (
          <tr key={log.id}>
            <td className="px-6 py-4">{log.id}</td>
            <td className="px-6 py-4">{log.serviceName}</td>
            <td className="px-6 py-4">
              <DetailsModal
                log={log}
                trigger={
                  <button className="px-4 py-2 border border-blue-600 rounded hover:bg-blue-50">
                    Details
                  </button>
                }
              />
            </td>
            <td className="px-6 py-4">
              <span
                className={`px-2 py-1 rounded-full text-sm ${
                  log.isSuccessful ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                }`}
              >
                {log.isSuccessful ? "Successful" : "Failed"}
              </span>
            </td>
            <td className="px-6 py-4">  <Moment  format="DD MMM YYYY hh:mm:ss A">
        {log.createdAt}
      </Moment></td>
        <td className="px-6 py-4">{log.userId}</td>
        {/* <td className="px-6 py-4">{log.user}</td> */}
        <td className="px-6 py-4">{log.comment || "N/A"}</td>
        <td className="px-6 py-4">{log.httpMethod}</td>
         
          </tr>
        ))
    )}
      </tbody>
    </table>
  );
};


  

export default ApiLogsTable;
